"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStartAndEndTime = formatStartAndEndTime;
function formatStartAndEndTime(timezonedDate, rule) {
    var _a = rule.start.split(':'), startHours = _a[0], startMinutes = _a[1];
    var _b = rule.end.split(':'), endHours = _b[0], endMinutes = _b[1];
    var today = timezonedDate.clone().hours(0).minutes(0);
    var startTime = today.clone().hours(+startHours).minutes(+startMinutes);
    var endTime = today.clone().hours(+endHours).minutes(+endMinutes);
    if (endTime.isSameOrBefore(startTime)) {
        endTime = endTime.add(1, 'day'); // Account for 12am - 12am schedule
    }
    return { startTime: startTime, endTime: endTime };
}
//# sourceMappingURL=formatStartAndEndTime.js.map